/**
 * OnboardingRouter — IDI-659 D3: only a dealer's admin reaches setup.
 *
 * - still loading → spinner
 * - signed out → /login
 * - not an admin (salesperson, field tech, …) or an IDI super-admin →
 *   sign-in's landing (field techs Jobs, others the Dashboard)
 * - admin → the setup wizard (which itself sends a finished dealer to the
 *   Dashboard, D2)
 *
 * The retired "Set Up Your Profile" flow is no longer routed to; nothing here
 * calls complete().
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import OnboardingWizard from './OnboardingWizard';
import { landingPath } from '../../utils/isFieldTech';
import { isSetupAdmin } from '../../utils/isSetupAdmin';

export default function OnboardingRouter() {
  const { user, isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
      </div>
    );
  }
  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }
  if (!isSetupAdmin(user)) {
    return <Navigate to={landingPath(user)} replace />;
  }
  return <OnboardingWizard />;
}
